import styled from 'styled-components'
import { Button, Card, Form } from 'react-bootstrap'
import { Small } from '../../../../typography'
import fonts from '../../../../const/fonts'

export const FormWrapper = styled(Form)`
  max-width: 75%;
  margin: 4rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const StyledButton = styled(Button)`
  display: block;
  margin: auto;
  border: none;
  width: 7rem;
`

export const NoteWrapper = styled(Small)`
  font-size: 12px;
  display: flex;
  justify-content: center;
`

export const CardContainer = styled.div`
  margin: 2rem 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .selected {
    background: ${({ theme }) => theme?.register?.subscription?.background};
  }
`

export const CardWrapper = styled(Card)`
  flex-grow: 1;
  margin: 8px;
  flex-basis: 10rem;
  max-width: 13.5rem;

  .selected {
    color: ${({ theme }) => theme?.register?.subscription?.color};
  }
`

export const CardBody = styled(Card.Body)`
  min-width: 10rem;
  padding: 10px;
  display: flex;
  cursor: pointer;
  font-size: ${fonts.tiny};
  justify-content: space-between;
`

export const ButtonWrapper = styled.div`
  display: flex;
`
